import { EnvConfig } from '../../config/EnvConfig'
import {
  GamesLanguages,
  oryxGameProvidersSupportingCashierEvent,
} from '../constants'
import { convertOptionsToQueryParams, generateURL } from './generateURL'
import { getMockURL } from './mockURL'

const locale = process.env.GATSBY_INTL_LOCALE
const language = GamesLanguages['*:*'][locale]

export const setOryxURL = ({
  isLoggedIn,
  params,
  providerData,
  isMobile,
  mobileSlug,
  desktopSlug,
  casinoProvider,
  providerSlug,
  isMock,
  depositUrl,
}) => {
  const isFunMode = !isLoggedIn || params?.playMode === 'FUN'
  const options = [
    {
      param: 'playMode',
      value: isFunMode ? 'FUN' : 'REAL',
    },
    {
      param: 'languageCode',
      value: language,
    },
    {
      param: 'lobbyUrl',
      value: EnvConfig.SITE_URL,
    },
    {
      param: 'token',
      value: isLoggedIn ? providerData?.token : '',
    },
  ]

  if (!oryxGameProvidersSupportingCashierEvent?.includes(providerSlug))
    options.push({
      param: 'cashierUrl',
      value: depositUrl,
    })

  const gameSlug = isMobile ? mobileSlug : desktopSlug
  const slug = `${gameSlug}/open`
  const baseURL = `${EnvConfig.ORYX_LAUNCH_URL}/${slug}`

  return isMock
    ? getMockURL({
        path: 'init',
        params: convertOptionsToQueryParams(options),
        casinoProvider,
        slug,
      })
    : generateURL({ baseURL, options })
}
